import { render, staticRenderFns } from "./preparar-certificado-admin.vue?vue&type=template&id=453f52c8&"
import script from "./preparar-certificado-admin.vue?vue&type=script&lang=js&"
export * from "./preparar-certificado-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports